import Window from '@components/Window';
import BriefWindow from '@components/Window/BriefWindow';
import DeleteWindow from '@components/Window/DeleteWindow';
import QuitWindow from '@components/Window/QuitWindow';
import TooShortWindow from '@components/Window/TooShortWindow/';
import WarningWindow from '@components/Window/WarningWindow/';

export const WINDOWS = {
  WARNING: 'WARNING',
  DELETE: 'DELETE',
  BRIEF: 'BRIEF',
  TOOSHORT: 'TOOSHORT',
  QUIT: 'QUIT',
};

export const Windows = {
  [WINDOWS.WARNING]: (props) => (
    <Window {...props}>
      <WarningWindow {...props}></WarningWindow>
    </Window>
  ),
  [WINDOWS.DELETE]: (props) => (
    <Window {...props}>
      <DeleteWindow {...props}></DeleteWindow>
    </Window>
  ),
  [WINDOWS.BRIEF]: (props) => (
    <Window {...props}>
      <BriefWindow {...props}></BriefWindow>
    </Window>
  ),
  [WINDOWS.TOOSHORT]: (props) => (
    <Window {...props}>
      <TooShortWindow {...props}></TooShortWindow>
    </Window>
  ),
  [WINDOWS.QUIT]: (props) => (
    <Window {...props}>
      <QuitWindow {...props}></QuitWindow>
    </Window>
  ),
};

export default WINDOWS;
